function Venues() {
  return (
    <div className="page-content">
      <h1>Venues list is coming very soon... Stay tuned ;D</h1>
    </div>
  );
}

export default Venues;
